import { useEffect } from 'react'
import { useCommandLine } from 'hooks/useCommandLine'
import useImportModal from 'hooks/useImportModal'

export const useImportCreateShortcut = () => {
  const { openImportModal } = useImportModal()
  const { addContext, removeContext } = useCommandLine()

  useEffect(() => {
    addContext('openImportModal', openImportModal)

    return () => removeContext('openNewEntrypointModal')
  }, [addContext, removeContext, openImportModal])
}
